import { MapfreButtonComponent } from '../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { MapfreIputWithValidationComponent } from '../../../../modules/mapfre-design-library/src/lib/_components/section-components/mapfre-input-with-validation/mapfre-input-with-validation.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router , RouterModule } from '@angular/router';
import { CreateAccountService } from '../../../../_services/forms/create-account/create-account-service.service';
import { FormGroup , FormsModule , ReactiveFormsModule } from '@angular/forms';
import {
  FormBaseControlService,
  AlertService,
  AcmicService,
} from '@mapfre-design-library/src/public_api';
import { AuthenticationService } from '../../../../_services/_iam/authentication-service.service';
import { AddPolicyDataService } from '../../../../_services/signup-process-service/add-policy-data.service';
import { UserService } from '../../../../_services/user.service';
import { ErrorRedirectionService } from '../../../../_services/error-service/error-redirection.service';
import { Location } from '@angular/common';

interface Res {
  firstName: string;
  lastName: string;
  publicId: string;
}

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MapfreIputWithValidationComponent, MapfreButtonComponent],
  selector: 'app-account-verification',
  templateUrl: './account-verification.component.html',
})
export class AccountVerificationComponent implements OnInit {
  inputs: any[];
  accountVerificationForm: FormGroup;
  policyNumber: string;
  userData: any;
  loader = false;
  showAlert = true;
  zipCode: string;
  email: any;
  user_detail: any = [];
  isAcmic: boolean;

  constructor(
    private createAccountService: CreateAccountService,
    private ipt: FormBaseControlService,
    private router: Router,
    private addPolicyDataService: AddPolicyDataService,
    private authenticationService: AuthenticationService,
    private userServe: UserService,
    private errorRedirectionService: ErrorRedirectionService,
    private alertService: AlertService,
    private location: Location,
    private acmicService: AcmicService
  ) {
    this.inputs = createAccountService.getNoPhoneNoEmailInputs();
    this.isAcmic = this.acmicService.isACMIC();
  }

  ngOnInit(): void {
    this.accountVerificationForm = this.ipt.toFormGroup(this.inputs);
    this.user_detail = this.userServe.getUserInfoInStorage();
    if (this.user_detail) {
      this.email = this.user_detail['userDetails']['email'];
    }

    this.addPolicyDataService.$newPolicy.subscribe((userData) => {
      this.userData = userData;
      this.userData.userDetails.email = this.email;
      this.policyNumber = userData.policyDetail.policynumber.policyNumber;
      this.accountVerificationForm
        .get('noPhoneEmail_zipcode')
        .setValue(this.userData.userDetails.zipCode);
      this.userServe.placeUserInfoInStorage(this.userData);
    });
  }

  goBack() {
    this.location.back();
  }

  validateNoPhoneNoEmail() {
    if (this.loader) {
      return false;
    }

    this.loader = true;
    this.accountVerificationForm.controls['createAc_email'].setErrors(null);
    this.accountVerificationForm.controls['noPhoneEmail_zipcode'].setErrors(
      null
    );

    const zipCodeValue = this.accountVerificationForm.get(
      'noPhoneEmail_zipcode'
    ).value;
    const email = this.accountVerificationForm.get('createAc_email').value;
    this.user_detail.userDetails.zipCode = zipCodeValue;
    this.authenticationService
      .validateZipAndEmail(
        zipCodeValue,
        email,
        this.policyNumber,
        this.user_detail
      )
      .subscribe(
        (data: Res) => {
          this.loader = false;
          const { firstName, lastName, publicId } = data;
          this.user_detail.userDetails = {
            ...this.user_detail.userDetails,
            firstName,
            lastName,
            publicId,
          };
          this.user_detail.userDetails.newEmail = email;
          this.user_detail.userDetails.isEmailEntered = true;
          if (this.user_detail.policyDetail) {
            this.user_detail.policyDetail.policynumber = {
              policyNumber: this.policyNumber,
            };
          } else {
            this.user_detail.policyDetail = {
              policynumber: { policyNumber: this.policyNumber },
            };
          }
          this.userServe.placeUserInfoInStorage(this.user_detail);
          this.addPolicyDataService.updateAddPolicy(this.user_detail);
          this.router.navigate(['/signup', 'validate-account']);
        },
        (err) => {
          this.loader = false;
          if (err.status === 400) {
            this.accountVerificationForm.controls['createAc_email'].setErrors({
              invalidEmail: true,
            });
            this.alertService.errorWithButton('EMAIL_IN_USE_NO_PHONE_EMAIL');
          } else if (err.status === 403) {
            this.accountVerificationForm.controls[
              'noPhoneEmail_zipcode'
            ].setErrors({ invalidZipCode: true });
          } else {
            this.errorRedirectionService.redirect(err.status);
          }
        }
      );
  }
}
